import { SubMenuIcon } from '@model-framework/menu';
import { SubMenuBox } from '@model-framework/menu/MenuBox';
import { StickyZoneTitlePosition } from '../../../domain';
import { faArrowUp, faArrowDown, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';

type Props = {
  titlePosition: StickyZoneTitlePosition;
  menuSize: number;
  isSelected: boolean;
  onClick(): void;
};

const titlePositionToIcon: { [key in StickyZoneTitlePosition]: IconDefinition } = {
  [StickyZoneTitlePosition.Top]: faArrowUp,
  [StickyZoneTitlePosition.Bottom]: faArrowDown,
  [StickyZoneTitlePosition.Left]: faArrowLeft,
  [StickyZoneTitlePosition.Right]: faArrowRight,
};

export const ZoneTitlePositionSubMenu: React.FC<Props> = ({ titlePosition, menuSize, isSelected, onClick }: Props) => {
  return (
    <>
      <SubMenuBox menuSize={menuSize} isSelected={isSelected} onClick={onClick} />
      <SubMenuIcon icon={titlePositionToIcon[titlePosition]} menuSize={menuSize} isSelected={isSelected} />
    </>
  );
};
